{
  "title": "@leny/bowlstats",
  "subtitle": "A small bowling stats tracker",
  "goals": {
    "avgScorePerGame": 120,
    "avgFirstBallPinfall": 6,
  }
}
